<template>
  <div id="app"  v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="conBox" >
      <Head></Head>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <div class="fullScreen" @click="change()">
        <img :src="$baseURL + fullScreenURL" alt="">
      </div>
    </div>
    
  </div>
</template>
<script>
import Head from './components/2D/Head';

export default {
  name: 'App',
  data(){
    return {
      loading: true,
      isFull: false,
      fullScreenURL: "image/fullScreen.png"
    }
  },
  components: {
    Head
  },
  methods: {
    change(){
      if(!this.isFull){
        this.fullScreenURL = "image/noFullScreen.png";
        this.kaishi();
        
      }else{
        this.fullScreenURL = "image/fullScreen.png";
        this.guanbi();
      }
      this.isFull = !this.isFull;
    },
    kaishi(){  
        var docElm = document.documentElement;  
        //W3C   
        if (docElm.requestFullscreen) {  
            docElm.requestFullscreen();  
        }  
            //FireFox   
        else if (docElm.mozRequestFullScreen) {  
            docElm.mozRequestFullScreen();  
        }  
            //Chrome等   
        else if (docElm.webkitRequestFullScreen) {  
            docElm.webkitRequestFullScreen();  
        }  
        
    } ,
  
    //退出全屏
    guanbi() {  
  
        if (document.exitFullscreen) {  
            document.exitFullscreen();  
        }  
        else if (document.mozCancelFullScreen) {  
            document.mozCancelFullScreen();  
        }  
        else if (document.webkitCancelFullScreen) {  
            document.webkitCancelFullScreen();  
        }  
        else if (document.msExitFullscreen) {  
            document.msExitFullscreen();  
        }  
    }  
  },
  created() {
    this.baseUrl = `${process.env.BASE_URL}`;
    this.$axios.get(this.baseUrl + 'data/productData.json')
    .then(res => {
      console.log(res);
    })
    this.Event.$on('load', (isload) => {
      console.log(isload);
      this.loading = isload;
    });
    this.Event.$on('carouselChange', (newIndex) => {
      console.log(newIndex);
    });
    
  }
}
</script>

<style>


</style>
